import { useMutation } from '@tanstack/react-query';
import { patchFetch } from '@legacy/utils/fetcher';
import { IUpdateWidgetOrderParams, IUpdateWidgetParams } from '../types';
import {
  WIDGETS_UPDATE_ROLE_URL_PATH,
  WIDGETS_UPDATE_ROLE,
  WIDGETS_UPDATE_ORDER_URL_PATH,
  WIDGETS_UPDATE_ORDER_KEY,
} from '../constants';

const updateWidgetRole = ({ widgetId, roleId, enabled }: IUpdateWidgetParams) =>
  patchFetch({
    path: `${WIDGETS_UPDATE_ROLE_URL_PATH}`,
    key: WIDGETS_UPDATE_ROLE,
    body: JSON.stringify({
      widgetId,
      roleId,
      enabled,
    }),
  });

export const usePutWidgetRole = () =>
  useMutation({
    mutationKey: [WIDGETS_UPDATE_ROLE],
    mutationFn: updateWidgetRole,
  });

const updateWidgetOrder = ({
  widgetId,
  displayOrder,
}: IUpdateWidgetOrderParams) =>
  patchFetch({
    path: `${WIDGETS_UPDATE_ORDER_URL_PATH}`,
    key: WIDGETS_UPDATE_ORDER_KEY,
    body: JSON.stringify({
      widgetId,
      displayOrder,
    }),
  });

export const usePutWidgetOrder = () =>
  useMutation({
    mutationKey: [WIDGETS_UPDATE_ORDER_KEY],
    mutationFn: updateWidgetOrder,
  });
